/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "MipIrdSelection": {
                "fields": {
                  "interchangeRateDesignator": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "interchangeCost": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isFinal": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "interchangeVariableAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "interchangeFixedAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MipCaptureGatewayProperties": {
                "fields": {
                  "irdSelection": {
                    "type": "squareup.esperanto.model.MipIrdSelection",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MipRefundGatewayProperties": {
                "fields": {
                  "irdSelection": {
                    "type": "squareup.esperanto.model.MipIrdSelection",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.MipIrdSelection && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.MipCaptureGatewayProperties && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.MipRefundGatewayProperties) {
  $root.addJSON(jsonData);
}

/**
 * Gateway properties for the Mastercard MIP (Mastercard Interface Processor) gateway.
 * Background can be found in the following design doc,
 * https://docs.google.com/document/d/1npzA8W2sF5BiRN1xyEO1ScArbnHDLek2Dp_4uLOE8xk/edit#heading=h.qc29q4v31vcp
 * Key concept is persisting the interchange rate designator (IRD) selected when clearing a
 * transaction and the associated cost.
 * Attributes of MIP IRD selection for either a Capture or a Refund
 *
 * SOURCE MipIrdSelection @ squareup/esperanto/model/mastercard_mip.proto at 20:1
 */
export const MipIrdSelection = $root.lookupType('squareup.esperanto.model.MipIrdSelection');
fixType(MipIrdSelection);
Builder.createAndAttachToType(MipIrdSelection);
/**
 * SOURCE MipCaptureGatewayProperties @ squareup/esperanto/model/mastercard_mip.proto at 46:1
 */
export const MipCaptureGatewayProperties = $root.lookupType('squareup.esperanto.model.MipCaptureGatewayProperties');
fixType(MipCaptureGatewayProperties);
Builder.createAndAttachToType(MipCaptureGatewayProperties);
/**
 * SOURCE MipRefundGatewayProperties @ squareup/esperanto/model/mastercard_mip.proto at 51:1
 */
export const MipRefundGatewayProperties = $root.lookupType('squareup.esperanto.model.MipRefundGatewayProperties');
fixType(MipRefundGatewayProperties);
Builder.createAndAttachToType(MipRefundGatewayProperties);